import { useParams } from 'react-router-dom';

export default function useParameters<T>() {
  const params = useParams() as T;
  return params;
}
